import React from 'react';
import { CalendarClock } from 'lucide-react';

export const PEAK_NOTE = 'Price is for standard dates (weekdays outside peak season). A supplement applies for 20 Dec to 5 Jan, long weekends and public holidays, school holidays, Diwali and special events. We confirm the exact amount before you pay anything.';

/** Peak-date / surcharge note shown next to every package price and on the quote forms. */
export default function PeakNote({ compact = false, className = '' }) {
  return (
    <p className={`vk-peaknote ${compact ? 'vk-peaknote--compact' : ''} ${className}`.trim()} data-testid="peak-note">
      <CalendarClock size={compact ? 14 : 16} aria-hidden /> <span>{PEAK_NOTE}</span>
    </p>
  );
}
